/**
 * The period picker's extra entry, pinned under the cycles: not a cycle, but dates the reader picks
 * -- the objective's own two dates on the form, a range to filter on in the toolbars. Period ids are
 * server UUIDs, so this literal can never collide with one.
 */
export const CUSTOM_DATES_OPTION_ID = 'custom-dates';

/**
 * The picker's widest entry, above the cycles: no window at all, so the lists show every objective
 * a reader may see -- including the ones whose own dates fall outside every cycle, which no cycle
 * can bring back into view. Like the entry above, a literal that can never collide with a UUID.
 */
export const ALL_PERIODS_OPTION_ID = 'all-periods';

/**
 * Where the lens lives: the address. `usePeriodParam` reads and writes these, and the links between
 * the objectives screens carry them, so both spell them from here rather than each their own.
 */
export const PERIOD_PARAM = 'period';
export const FROM_PARAM = 'from';
export const TO_PARAM = 'to';

/** The page of a paged list under the lens: a new lens re-numbers the list, and drops it. */
export const PAGE_PARAM = 'page';

/** The two bounds of a custom range, each empty until the reader picks it. */
export interface PeriodDateRange {
    from: string;
    to: string;
}
